import { EditOutlined } from "@mui/icons-material";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
} from "@mui/material";
import React, { useState } from "react";
import { AlertComponent } from "../../../../common/components";
import { AlertMessage } from "../../../tenant/tenant-details/tenant-details-types";
import InsertLinkOutlinedIcon from "@mui/icons-material/InsertLinkOutlined";

interface LearnMoreButtonProps {
  primaryColor?: string;
  isForSharing: boolean;
  link?: string;
  setLink?: any;
  canWrite?: boolean;
}

const LearnMoreButton: React.FC<LearnMoreButtonProps> = ({
  primaryColor = "#007BFF",
  isForSharing = false,
  link = "",
  setLink,
  canWrite = false,
}) => {
  // const [link, setLink] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [tempLink, setTempLink] = useState("");
  const [urlError, setURLError] = useState("");
  const [alertMessage, setAlertMessage] = React.useState<AlertMessage>({
    open: false,
    message: "",
    type: undefined,
  });

  const openModal = () => {
    setTempLink(link);
    setShowModal(true);
  };

  const isValidURL = (url: string): boolean => {
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  };

  const saveLink = () => {
    if (!tempLink) {
      setURLError("Please enter or copy URL");
      return;
    } else if (!isValidURL(tempLink)) {
      setURLError("Please enter a valid URL ");
      return;
    } else {
      setURLError("");
    }
    if (setLink) {
      setLink((prev: any) => ({
        ...prev,
        btnUrl: tempLink,
      }));
    }
    setAlertMessage({
      open: true,
      message: "Link updated successfully",
      type: "success",
    });
    setShowModal(false);
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        {link ? (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <button
              style={{
                padding: "20px",
                backgroundColor: primaryColor,
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                height: "50px",
                width: "128px",
                fontSize: "15px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontFamily: "Roboto, sans-serif",
              }}
            >
              Learn More
            </button>
          </a>
        ) : (
          <button
            title="Attach a link"
            style={{
              padding: "20px",
              backgroundColor: primaryColor,
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              height: "50px",
              width: "128px",
              fontSize: "16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              opacity: 0.9,
              fontFamily: "Roboto, sans-serif",
            }}
          >
            Learn More
          </button>
        )}

        {!isForSharing && (
          <button
            onClick={openModal}
            style={{
              background: "#fff",
              border: "1px solid #ccc",
              cursor: `${canWrite ? "pointer" : "not-allowed"}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              padding: "4px",
              margin: "20px 8px",
              fontFamily: "Roboto, sans-serif",
            }}
            disabled={!canWrite}
          >
            <InsertLinkOutlinedIcon fontSize="small" />
          </button>
        )}
      </div>

      {/* Modal */}
      {showModal && (
        <Dialog
          open={showModal}
          onClose={() => setShowModal(false)}
          aria-labelledby="attach-link"
          className="update-popup-wrapper"
          slotProps={{
            paper: {
              sx: {
                minWidth: "570px",
                minHeight: "280px",
                borderBottomLeftRadius: "30px",
                borderBottomRightRadius: "30px",
                top: 0,
                margin: 0,
                position: "absolute",
              },
            },
          }}
        >
          <DialogTitle
            id="attach-link"
            style={{ borderBottom: "1px solid #ddd" }}
          >
            Attach Link
          </DialogTitle>
          <DialogContent style={{ padding: "20px 24px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                justifyContent: "space-between",
                marginTop: "16px",
              }}
            >
              <InputLabel>Enter URL</InputLabel>
              <div style={{ flex: 1 }}>
                <input
                  type="text"
                  value={tempLink}
                  onChange={(e) => {
                    const value = e.target.value;
                    setTempLink(value);
                    if (isValidURL(value)) {
                      setURLError("");
                    }
                  }}
                  placeholder="Enter or copy URL"
                  onFocus={(e) => e.target.select()}
                  style={{
                    width: "336px",
                    padding: "10px",
                    borderRadius: "4px",
                    border: "none",
                    backgroundColor: "#f0f0f0",
                    borderTop: "2px solid #e30000",
                    marginLeft: "20px",
                    outline: "none",
                  }}
                />
              </div>
            </div>
            <div
              style={{
                color: "#e30000",
                display: urlError ? "block" : "none",
                fontSize: "12px",
                marginLeft: "114px",
                marginTop: "8px",
              }}
            >
              {urlError}
            </div>
          </DialogContent>
          <DialogActions
            className="button-wrapper"
            style={{ padding: "16px 24px" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "1.5rem",
              }}
            >
              <button
                onClick={() => {
                  setShowModal(false);
                  setURLError("");
                }}
                style={{
                  marginRight: "1rem",
                  padding: "10px 20px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                  width: "84px",
                  fontFamily: "Roboto, sans-serif",
                }}
              >
                Cancel
              </button>
              <button
                onClick={saveLink}
                style={{
                  padding: "10px 20px",
                  borderRadius: "6px",
                  border: "none",
                  backgroundColor: primaryColor,
                  color: "#fff",
                  cursor: "pointer",
                  width: "84px",
                  fontFamily: "Roboto, sans-serif",
                }}
              >
                Attach
              </button>
            </div>
          </DialogActions>
        </Dialog>
      )}
      {alertMessage.open && (
        <AlertComponent
          message={alertMessage.message}
          type={alertMessage.type || "info"}
          open={alertMessage.open}
          onClose={() => setAlertMessage({ open: false })}
        />
      )}
    </div>
  );
};

export default LearnMoreButton;
